<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="filteredMedicationClasses"
        :items-per-page="10"
        class="elevation-0 custom-data-table"
        :no-data-text="noDataText"
        :height="tableHeight"
        fixed-header
        :loading="tableLoading"
        density="compact"
      >
        <template v-slot:top>
          <div class="d-flex justify-space-between align-center pa-4">
            <span class="text-h5">Medication Classes</span>
            <div class="d-flex align-center">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                variant="outlined"
                density="compact"
                style="width: 350px; margin-right: 16px"
              ></v-text-field>
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="openCreateDialog"
              >
                Create Medication Class
              </v-btn>
            </div>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            size="small"
            variant="text"
            color="primary"
            @click="editMedicationClass(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            size="small"
            variant="text"
            color="error"
            @click="deleteMedicationClass(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create Medication Class Dialog -->
    <CreateMedicationClassDialog
      v-model="showCreateDialog"
      @created="handleMedicationClassCreated"
    />

    <!-- Edit Medication Class Dialog -->
    <EditMedicationClassDialog
      v-model="showEditDialog"
      :medicationClass="selectedMedicationClass"
      @updated="handleMedicationClassUpdated"
    />

    <!-- Delete Medication Class Dialog -->
    <DeleteMedicationClassDialog
      v-model="showDeleteDialog"
      :medicationClass="selectedMedicationClass"
      @deleted="handleMedicationClassDeleted"
    />
  </div>
</template>

<script>
import CreateMedicationClassDialog from "@/components/Medication/Dailogs/CreateMedicationClassDialog.vue";
import EditMedicationClassDialog from "@/components/Medication/Dailogs/EditMedicationClassDialog.vue";
import DeleteMedicationClassDialog from "@/components/Medication/Dailogs/DeleteMedicationClassDialog.vue";
import GetMedicationClasses from "@/mixins/Medication/GetMedicationClasses";

export default {
  name: "MedicationClassCard",
  mixins: [GetMedicationClasses],
  components: {
    CreateMedicationClassDialog,
    EditMedicationClassDialog,
    DeleteMedicationClassDialog,
  },
  data() {
    return {
      showCreateDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      tableLoading: false,
      selectedMedicationClass: null,
      selectedIndex: -1,
      medicationClasses: [],
      search: "",
      windowHeight: window.innerHeight,
      headers: [
        { title: "Class Name", key: "class_name", sortable: true },
        { title: "Actions", key: "actions", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    noDataText() {
      return "No medication classes found. Click 'Create Medication Class' to add one.";
    },
    tableHeight() {
      return this.windowHeight - 280;
    },
    filteredMedicationClasses() {
      if (!this.search) {
        return this.medicationClasses;
      }

      const searchTerm = this.search.toLowerCase().trim();
      return this.medicationClasses.filter((medClass) => {
        return (
          medClass.class_name &&
          medClass.class_name.toLowerCase().includes(searchTerm)
        );
      });
    },
  },
  async mounted() {
    this.updateWindowHeight();
    window.addEventListener("resize", this.updateWindowHeight);
    this.loadMedicationClasses();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowHeight);
  },
  methods: {
    onTabActivated() {
      this.loadMedicationClasses();
    },
    async loadMedicationClasses() {
      this.tableLoading = true;
      try {
        await this.fetchMedicationClasses();
        this.medicationClasses = this.medicationClassesList;
      } catch (error) {
        console.error("Error loading medication classes:", error);
        this.medicationClasses = [];
      } finally {
        this.tableLoading = false;
      }
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    openCreateDialog() {
      this.showCreateDialog = true;
    },
    async handleMedicationClassCreated() {
      await this.loadMedicationClasses();
    },
    editMedicationClass(medClass) {
      this.selectedMedicationClass = { ...medClass };
      this.selectedIndex = this.medicationClasses.findIndex(
        (m) => m.class_id === medClass.class_id
      );
      this.showEditDialog = true;
    },
    async handleMedicationClassUpdated() {
      await this.loadMedicationClasses();
      this.selectedIndex = -1;
      this.selectedMedicationClass = null;
    },
    deleteMedicationClass(medClass) {
      this.selectedMedicationClass = { ...medClass };
      this.selectedIndex = this.medicationClasses.findIndex(
        (m) => m.class_id === medClass.class_id
      );
      this.showDeleteDialog = true;
    },
    async handleMedicationClassDeleted() {
      await this.loadMedicationClasses();
      this.selectedIndex = -1;
      this.selectedMedicationClass = null;
    },
  },
};
</script>

